// TODO: Remove from `core-js@4`
require('./es.string.match-all');
